import ClassNames from "classnames";
import { FunctionComponent, ReactNode, RefObject } from "react";
import moduleBaseStyles from "../stylesheets/components/module-base.module.css";
import { css } from "../utils/emotion.js";

interface Props {
  id: string;
  title: string | undefined;
  subtitle: string | undefined;
  colors: { background?: string; color?: string } | undefined;
  className?: string;
  innerRef?: RefObject<HTMLDivElement | null>;
  children: ReactNode;
}

const getModuleTag = ({
  title,
  subtitle,
}: {
  title: string | undefined;
  subtitle: string | undefined;
}) => (title || subtitle ? "section" : "div");

const ModuleWithHeadings: FunctionComponent<Props> = ({
  children,
  title,
  subtitle,
  id,
  colors,
  className,
  innerRef,
}) => {
  const TagName = getModuleTag({ title, subtitle });
  return (
    <TagName
      id={id}
      ref={innerRef}
      className={ClassNames(
        moduleBaseStyles.Module,
        className,
        css({ backgroundColor: colors?.background, color: colors?.color }),
      )}
    >
      {children}
    </TagName>
  );
};

export default ModuleWithHeadings;
